module.exports = __webpack_public_path__ + "static/img/NSW-6.c0805ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-6.jpg
// module id = 5+7S
// module chunks = 0